export default __webpack_public_path__ + "static/media/cat_watersportvereniging.5c730210.svg";